import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Feedback } from '../feedback';
import { useSelector, useDispatch } from 'react-redux'


const ChatReply = () => {
    // const dispatch = useDispatch();
    const chatReplyBn = useSelector((state) => state.asr.chatReply);
    const chatReplyEn = useSelector((state) => state.asr.chatReplyEn);
    const cost = useSelector((state) => state.asr.cost);
    const chatReply = chatReplyBn === "" ? "" : "বাংলা: " + chatReplyBn + "\n\nEnglish: " + chatReplyEn + "\n\n" + cost;

    return (
        <div className='chat-reply mini-card'>
            <h4>Chat</h4>
            <div>
                <textarea
                    value={ chatReply }
                    rows="7" style={{"width": "100%"}}
                    readOnly />
            </div>           
            <div>
                <Feedback
                    type = {"chat"} />
            </div>
        </div>
    );
}

export default ChatReply;